// extracted by mini-css-extract-plugin
module.exports = {"test_span":"LGS_test_span__XfM7A"};